import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import type { Bundle } from "@memorang/types";
import type { BundleMetaData } from "@memorang/types";
import type { CreateCheckoutSessionResponse } from "./types";

export async function fetchProductDetails({
	numericId,
}: {
	numericId: number;
}): Promise<Bundle> {
	const { data } = await apiAxios.post(API_ENDPOINTS.PRODUCT_DETAILS, {
		numericId,
	});

	return data.data.productDetails;
}

export async function fetchProductMetadata({
	productId,
}: {
	productId: string;
}): Promise<BundleMetaData> {
	const { data } = await apiAxios.post(API_ENDPOINTS.PRODUCT_METADATA, {
		productId,
	});

	return data.data;
}

export async function createCheckoutSession({
	userId,
	payment,
}: {
	userId: string;
	payment: {
		productId: string;
		quantity: number;
		planId: number;
		successUrl: string;
		cancelUrl: string;
	};
}): Promise<CreateCheckoutSessionResponse> {
	const { data } = await apiAxios.post(
		API_ENDPOINTS.COMMERCE_PRODUCT_CHECKOUT,
		{
			payment,
			userId,
		},
	);

	return data.data;
}
